import React from 'react';
import { NavLink as RRDNavLink, NavLinkProps } from 'react-router-dom';
import { notMyBusinessAnymore } from 'shared/consts';

interface Props extends NavLinkProps {
  to: string; // only const
}

export const NavLink: React.FC<Props> = (props) => {
  if (notMyBusinessAnymore.some((regexp) => regexp.test(props.to))) {
    const { to, ...rest } = props;
    return <a href={props.to} {...rest} />;
  }

  return <RRDNavLink {...props} />;
};
